import React from 'react';
import Video from './video';
import { BrainIcon, CloudIcon, ComputerIcon, IdeaIcon } from '@/assets/icons';
import { HowWorksShadow } from '@/assets/shadow';
import useShowMore from '@/utils/useShowMore';
import { Card, Head, Paragraph, SubHead } from '@/components/card';
import { Container, Content, Cta, Section, Title } from '@/components/section';
import { BOOK_DEMO_URL, VIDEO_URL } from '@/config-global';
import Link from 'next/link';
interface DataProps {
  title: string;
  icon: React.ReactNode;
  subTitle: string;
  description: string;
}

const Item: React.FC<{ item: DataProps }> = ({ item }) => {
  const { toggle, isMore } = useShowMore(item.description, 100);
  return (
    <Card>
      <div className="absolute -left-8 top-6 h-1 w-36 bg-gradient-to-r from-[#2D009E] via-[#B3304A] to-[#EF4F34]" />
      <div className="absolute right-6 top-6">{item.icon}</div>
      <Head className="mt-4 pr-14">{item.title}</Head>
      {item.subTitle && <SubHead>{item.subTitle}</SubHead>}
      <Paragraph className="mt-6">
        {/* {str} */}
        {item.description}
      </Paragraph>
      <div className="mt-9 hidden w-full items-center justify-end">
        <button
          className="leading-0 cursor-pointer align-bottom font-medium text-orange"
          onClick={toggle}
        >
          {isMore ? 'Show less' : 'Show more'}
        </button>
      </div>
    </Card>
  );
};

const Process: React.FC = () => {
  const data: DataProps[] = [
    {
      title: 'Free Trial  - 4 Weeks',
      subTitle: '',
      description:
        'Nestflo offers a 4-week Premium Free Trial to new users, allowing you to experience how our software can transform your enquiry management, risk-free. The trial is customized to your needs, ensuring full setup and smooth operation. We won’t start the trial until you’re ready, activating it once you’ve generated a high-quality tenant report from your selected portals.',
      icon: <IdeaIcon className="w-12 shrink-0 xl:w-14" />
    },
    {
      title: 'Easy & Fast onboarding',
      subTitle: '',
      description:
        'Nestflo offers a fast and seamless onboarding experience, with instant sign-up and 24-hour setup for platforms like OpenRent. Major portals, such as Rightmove, may take 1–3 days. You do not need to manually input property data or upload data from your main CRM or Excel sheet into the Nestflo system.',
      icon: <BrainIcon className="w-12 shrink-0 xl:w-14" />
    },
    {
      title: 'White labelled solution',
      subTitle: '',
      description:
        'Nestflo provides a white-labeled property microsite, a website chatbot, and customer communications, allowing you to use Nestflo with your logo and branding—impressing your customers with its new features!',
      icon: <ComputerIcon className="w-12 shrink-0 xl:w-14" />
    },
    {
      title: 'Customer Success Support',
      subTitle: '',
      description:
        'Nestflo provides comprehensive training and round-the-clock support to help clients maximize the platform. Every agency gets support with easy scheduling via Zoho Booking for same-day consultations. Our Knowledge Base offers 24/7 step-by-step guides, while a ticketing system ensures prompt issue resolution and software updates. All support services are included at no extra cost.',
      icon: <CloudIcon className="w-12 shrink-0 xl:w-14" />
    }
  ];
  return (
    <Section id="link_4">
      <picture className="pointer-events-none absolute inset-x-0 top-[-600px] -z-20 opacity-60">
        <HowWorksShadow className="h-auto w-full" />
      </picture>
      <Container>
        <Title
          text="GETS YOU STARTED"
          className="mx-auto w-full max-w-screen-lg font-medium"
        />
        <Content>
          <div className="mx-auto w-full max-w-screen-lg">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-5 md:gap-12">
              {data.map((item, index) => (
                <Item item={item} key={index} />
              ))}
            </div>
          </div>
        </Content>
        <div className="flex w-full flex-col items-center">
          <Link href="https://office.nestflo.ai/package/trial/" target="_blank">
            <Cta>Sign up now</Cta>
          </Link>
        </div>
      </Container>
    </Section>
  );
};

export default Process;
